import {AfterContentInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject, Observable, Subscription}                 from 'rxjs';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridStatusColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridEditColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ApDynGridGroupColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  LanguageStore
}                                                                  from '../../stores/translation/language.store';
import {filter, map, skip}                                         from 'rxjs/operators';
import {MapViewMode}                                               from '../../ap-interface';
import {
  MapViewStore
}                                                                  from '../../stores/layout/mapview.store';
import {
  ApUtilService
}                                                                  from '../../ap-utils/service/ap-util.service';
import {
  FormStore
}                                                                  from '../../stores/layout/form.store';
import {
  FieldStore
}                                                                  from '../../stores/farm/field.store';
import {
  FertilizerStore
}                                                                  from '../../stores/base-data/fertilizer.store';
import {
  CropTypeStore
}                                                                  from '../../stores/base-data/crop.types.store';
import {
  ApDynGridPagerWizardButton,
  ApDynGridPagerWizardConfig,
  ApDynGridPagerWizardSection
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {
  ApDynformsConfigFieldset
}                                                                  from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigNumerictextbox
}                                                                  from '../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {
  ApDynformsConfigPlaceholder
}                                                                  from '../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {
  ApDynformsConfigDatepicker
}                                                                  from '../../ap-dynforms/config/ap-dynforms-config-datepicker';
import {
  ModalDialogStore
}                                                                  from '../../stores/dialog/modal.dialog.store';
import {
  IModalDialogData,
  ModalDialogButtonDisable
}                                                                  from '../../ap-interface/interfaces/ap-modaldialog-data.interface';
import {
  CampaignYearStore
}                                                                  from '../../stores/login/campaignyear.store';
import {
  ApTranslationService
}                                                                  from '../../ap-utils/service/ap-translation.service';
import {
  NFertilizationStore
}                                                                  from '../../stores/n-fertilization/n-fertilization.store';
import {
  ApDynComponentComponent
}                                                                  from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynformsConfigComboBox
}                                                                  from '../../ap-dynforms/config/ap-dynforms-config-combobox';
import {
  DriverStore
}                                                                  from '../../stores/docu/driver.store';
import {
  MachineStore
}                                                                  from '../../stores/docu/machine.store';
import {
  InstrumentStore
}                                                                  from '../../stores/docu/instrument.store';
import {ObjectFactory}                                             from 'ts-tooling';
import {
  GetRoundNumericService
}                                                                  from '../../ap-utils/service/get-round-numeric.service';
import {
  INFertilizationBookingGridData
}                                                                  from './ap-n-fertilization-booking-configs/n-fertilization-booking-types';
import {ApTimeSpanUtil, GetRoundNumericPipe}                       from '../../ap-utils';
import {
  CombinedFertilizer
}                                                                  from '../../types/common-types';
import {
  FertilizerService
}                                                                  from '../../services/data/fertilizer.service';
import {
  ApDynformsConfigTimepicker
}                                                                  from '../../ap-dynforms/config/ap-dynforms-config-timepicker';
import {
  CampaignYearService
}                                                                  from '../../services/data/campaign-year.service';
import {
  ApDateService
}                                                                  from '../../ap-core/services/ap-date-service';
import {
  FertilizationManagementService
}                                                                  from '../../services/data/fertilization-management.service';
import {
  nameOf
}                                                                  from '../../ap-core/utils/ap-name-of';
import IGuid = System.IGuid;
import INFertilizationPlanBook = Data.TaskManagement.INFertilizationPlanBook;
import IDatasetFieldMap = Data.Sensor.IDatasetFieldMap;
import TaskManagementStatus = Data.TaskManagement.TaskManagementStatus;
import IDriver = Data.DocuContext.Driver.IDriver;
import IInstrument = Data.DocuContext.Instrument.IInstrument;
import IMachine = Data.DocuContext.Machine.IMachine;

@Component({
  selector: 'ap-n-fertilization-booking',
  template: `
    <ap-dyncomponent [caption]="caption"
                     [headerIcon]="'ap-icon-n-fertilization'"
                     [columns]="columns"
                     [canCreate]="false"
                     [items]="items$ | async"
                     [pager]="pager"
                     (edit)="onEdit($event)">
    </ap-dyncomponent>
  `,
  styles: []
})
export class ApNFertilizationBookingComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public items$ = new BehaviorSubject<INFertilizationBookingGridData[]>([]);
  public pager: ApDynGridPagerWizardConfig;
  public columns: ApDynGridColumnConfigBase[];
  public caption: string;

  private _book = true;
  private _editId: IGuid;
  private _subscriptions: Subscription[] = [];

  constructor(private campaignYearStore: CampaignYearStore,
              private cropTypeStore: CropTypeStore,
              private driverStore: DriverStore,
              private fertilizerStore: FertilizerStore,
              private fieldStore: FieldStore,
              private formStore: FormStore,
              private instrumentStore: InstrumentStore,
              private languageStore: LanguageStore,
              private machineStore: MachineStore,
              private mapViewStore: MapViewStore,
              private modalDialogStore: ModalDialogStore,
              private nFertilizationStore: NFertilizationStore,
              private roundNumericService: GetRoundNumericService,
              private translationService: ApTranslationService,
              private fertilizerService: FertilizerService,
              private campaignYearService: CampaignYearService,
              private dateService: ApDateService,
              private fertilizationManagementService: FertilizationManagementService,
              private roundNumericPipe: GetRoundNumericPipe) {
  }

  public ngOnInit(): void {
    const data = this.formStore.Listen(s => s.updateComponent).getValue().data;
    this._book = data.book;
    this.caption = data.book ? 'Global__Booking' : 'Global__Reset';
    this.columns = this._getColumns();
    this.pager = this._getPager();
  }

  public ngAfterContentInit(): void {
    this._subscriptions.push(this.modalDialogStore.Listen(s => s.result).pipe(skip(1)).subscribe((result) => {
      if (result.key === 'apply') {
        this._updateItems({ids: [this._editId], value: result.formValues});
      }
    }));
    this._loadDataFromStore();
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  public onEdit(data: INFertilizationBookingGridData): void {
    const dialog = {
      title: this.translationService.translate('Admin_Pages_Popups__Book'),
      message: !this._isApplicationRateValid(data.ApplicationRate) ? 'Global__ApplicationRateZero_Dialog_Message' : null,
      show: true,
      buttons: [
        {
          key: 'cancel',
          text: 'Global__Cancel',
          primary: false
        },
        {
          key: 'apply',
          text: 'Global__Ok',
          primary: true,
          disable: ModalDialogButtonDisable.FormInvalid,
        }
      ],
      formConfig: {
        fieldSets: this._fieldSets(data, this.modalDialogStore.listenChanges()),
        validators: undefined,
        asyncValidators: undefined,
        values: ObjectFactory.Copy(data)
      }
    } as IModalDialogData;
    this._editId = data.Id;
    this.modalDialogStore.setModalDialogData(dialog);
  }

  private _booking(): void {
    if (this._book) {
      const selectedItems = this.dynComponent.getSelectedItems() as INFertilizationBookingGridData[];
      this.nFertilizationStore.BookPlanBooks(this._updateData(selectedItems));
    } else {
      this.nFertilizationStore.UnBookPlanBooks(
        this.dynComponent.getSelectedItems().map((planBookGridItem: INFertilizationBookingGridData) => {
            return {
              logfile: undefined,
              planBook: planBookGridItem.SourceItem
            };
          }
        ));
    }
    this._formClose();
  }

  private _formClose(): void {
    this.formStore.closeForm();
  }

  private _loadDataFromStore(): void {
    this._subscriptions.push(this.formStore.Listen(s => s.updateComponent).pipe(
      map((comp) => comp.data.dataItem['PlanBooks']),
      map((planBooks: INFertilizationPlanBook[]) => {
        return planBooks.filter((planBook) => !planBook.BookedBy === this._book).map((planBook) => {
          const applicationRate = planBook.ApplicationRate ?? 0;
          const field = this.fieldStore.getFieldById(planBook.FieldId);
          const fieldGeom = this.fieldStore.getCurrentFieldGeom(field);
          const fertilizer = this.fertilizerStore.getFertilizer(planBook.ProductId);
          const fertilizerFactor = this.fertilizationManagementService.getFertilizerContentN(planBook.ProductId);
          const driver = this.driverStore.getDriverById(planBook.ExportDriver);
          const machine = this.machineStore.getMachineById(planBook.ExportMachine);
          const instrument = this.instrumentStore.getInstrumentById(planBook.ExportInstrument);
          const productAmount = this.fertilizationManagementService.calculateProductAmountN(planBook.ProductId, applicationRate, fieldGeom.AreaHa, planBook.Factor);
          const gridStatus = this._getGridStatus(planBook.Status);
          return {
            Id: planBook.Id,
            FieldId: field.Id,
            Status: planBook.Status,
            StatusClass: gridStatus.Class,
            StatusDesc: gridStatus.Desc,
            FieldName: field.FieldName,
            Nr: field.FieldNumber,
            TNr: field.FieldSubnumber,
            NrTNr: this.fieldStore.getFieldNumberAndSubNumber(field),
            Driver: driver,
            Machine: machine,
            Instrument: instrument,
            FertilizationDate: new Date(planBook.ApplicationDate),
            CropTypeName: this.cropTypeStore.GetCropTypeName(planBook.MainCropId),
            IsExported: !!planBook.ExportedBy,
            ProductName: this.fertilizerService.getFertilizerProductName(fertilizer),
            ApplicationRate: applicationRate,
            Average: applicationRate * (planBook.Factor ?? 0),
            Applied: productAmount ?? 0,
            FertilizerAreaFactor: fertilizerFactor / (fieldGeom?.AreaHa ?? 1),
            ApplicationRateFactor: planBook.Factor ?? 1,
            Duration: this.dateService.getDateWithTimeFromMilliseconds(planBook.TEnd?.TotalMilliseconds ?? 0),
            FieldGeom: fieldGeom,
            Fertilizer: fertilizer,
            SourceItem: planBook
          } as INFertilizationBookingGridData;
        });
      })
    ).subscribe((items: INFertilizationBookingGridData[]) => {
      this.items$.next(items);
      setTimeout(() => this.dynComponent.dynGrid.gridPaging.setSelectedKeys(items.map(x => x.Id)));
    }));
  }

  // FF: Fix calculation of Application_Rate and content calculation of organic fertilizer
  private _updateData(planBookGridItems: INFertilizationBookingGridData[]): {
    planBook: INFertilizationPlanBook,
    logfile: IDatasetFieldMap
  }[] {
    return planBookGridItems.map(planBookGridItem => {
      const planBookToUpdate = ObjectFactory.Copy(planBookGridItem.SourceItem);
      if (planBookToUpdate) {
        planBookToUpdate.TStart = ApTimeSpanUtil.getEmptyTimeSpan();
        planBookToUpdate.TEnd = ApTimeSpanUtil.getTimeSpanFromDate(planBookGridItem.Duration, true);
        planBookToUpdate.ExportDriver = planBookGridItem.Driver?.Id;
        planBookToUpdate.ExportMachine = planBookGridItem.Machine?.Id;
        planBookToUpdate.ExportInstrument = planBookGridItem.Instrument?.Id;
        planBookToUpdate.ApplicationDate = this.dateService.getDateNoon(planBookGridItem.FertilizationDate);
        planBookToUpdate.Factor = planBookGridItem.ApplicationRateFactor;
      }
      return {planBook: planBookToUpdate, logfile: undefined};
    });
  }

  private _updateItems(submitData: { ids: IGuid[], value: any }): void {
    this.items$.next(this.items$.getValue().map((item: INFertilizationBookingGridData) => {
      if (submitData.ids.includes(item.Id)) {
        if (!!submitData.value.FertilizationDate) {
          item.FertilizationDate = new Date(submitData.value.FertilizationDate);
        }
        if (!!submitData.value.Duration) {
          item.Duration = submitData.value.Duration;
        }
        if (!!submitData.value.Driver) {
          item.Driver = this.driverStore.getDriverById(submitData.value.Driver);
        }
        if (!!submitData.value.Instrument) {
          item.Instrument = this.instrumentStore.getInstrumentById(submitData.value.Instrument);
        }
        if (!!submitData.value.Machine) {
          item.Machine = this.machineStore.getMachineById(submitData.value.Machine);
        }
        if (submitData.value.Average) {
          item.Applied = submitData.value.Applied;
          item.Average = this.roundNumericService.roundAsNumber(submitData.value.Average);
          if (this._isApplicationRateValid(item.ApplicationRate)) {
            item.ApplicationRateFactor = item.Average / item.ApplicationRate;
          } else {
            item.ApplicationRateFactor = 1;
          }
        }
      }
      return item;
    }));
  }

  private _getColumns(): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridStatusColumnConfig({
        field: 'Status',
        class: 'StatusClass',
        description: 'StatusDesc',
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Number',
        field: 'Nr',
        width: 60,
        hide: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini_Subnumber',
        field: 'TNr',
        width: 60,
        hide: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Number',
        field: 'NrTNr',
        width: 70,
        hide: new ApDynGridColumnHideConfig({
          selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((mapMode) => mapMode === MapViewMode.HIDE))
        })
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'FieldName',
        title: 'Docu_Ini__Field',
        headerFilterable: true,
        width: 180,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Area',
        field: 'FieldGeom.AreaHa',
        headerFilterable: true,
        width: 60,
        format: 'n3'
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__CropType',
        field: 'CropTypeName',
        filterable: true,
        width: 100,
        headerFilterable: true,
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Average_Amount',
        headerExtraLines: ['Global__KgNPerHa'],
        field: 'Average',
        width: 60,
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [0]
        }]
      }),
      new ApDynGridGroupColumnConfig({
        title: 'Global__Product',
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            field: 'ProductName',
            title: 'Docu_Ini__Name',
            width: 100
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'Applied',
            title: 'Global__Sum_Goods',
            cssClass: 'right',
            width: 60,
            format: 'n',
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [0]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'Fertilizer.Unit.Description',
            title: '',
            width: 40,
            filterable: false,
            sortable: false
          }),
        ]
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'FertilizationDate',
        title: 'Nutrients__FertilizationDate',
        hide: true,
        width: 80,
        filterable: true,
        format: this.languageStore.Listen(s => s.selectedLanguage).getValue().DateFormat,
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Duration',
        field: 'Duration',
        width: 60,
        format: 'HH:mm',
        hide: true
      }),
      new ApDynGridGroupColumnConfig({
        title: 'agrioptions_resources',
        hide: true,
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            field: 'Machine.NameWithSign',
            title: 'Base__Engine',
            width: 100,
            hide: true,
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'Instrument.Name',
            title: 'AgriConnect_Ini__Tool',
            width: 100,
            hide: true
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'Driver.ShortFullName',
            title: 'Docu_Ini__Motorist',
            width: 100,
            hide: true
          })
        ]
      }),
      new ApDynGridEditColumnConfig({})
    ];
  }

  private _getPager(): ApDynGridPagerWizardConfig {
    const nextTitle = this._book ? 'Admin_Pages_Popups__Book' : 'Global__Reset';
    return new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardButton('Global_Back_With_Arrow', ApUtilService.createEventEmitter(this._formClose.bind(this), this._subscriptions)),
      new ApDynGridPagerWizardSection(),
      new ApDynGridPagerWizardButton(nextTitle, ApUtilService.createEventEmitter(this._booking.bind(this), this._subscriptions),
        {active: this.dynComponent.SelectedItems$.pipe(map((items) => items.length !== 0))}),
      {
        formConfig: {
          showMassEdit: false,
          onSubmit: ApUtilService.createEventEmitter(this._updateItems.bind(this), this._subscriptions),
          config: this._getPagerFieldSets()
        }
      }
    );
  }

  private _getPagerFieldSets(): ApDynformsConfigFieldset[] {
    const selectedCampaignYear = this.campaignYearStore.getSelectedCampaignYear().Year;
    const campaignYearRange = this.campaignYearService.getCampaignYearRange(selectedCampaignYear);
    return [
      new ApDynformsConfigFieldset({
        key: 'Time',
        legend: 'Docu_Ini__Time',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigDatepicker({
            key: 'FertilizationDate',
            label: 'Nutrients__FertilizationDate',
            minDate: campaignYearRange.StartYear,
            maxDate: campaignYearRange.EndYear,
          }),
          new ApDynformsConfigTimepicker({
            key: 'Duration',
            label: 'Docu_Ini__Duration',
            format: 'HH:mm',
            minSteps: 5,
            secSteps: 60
          })
        ]
      }),
      new ApDynformsConfigFieldset({
        key: 'Resources',
        legend: 'Settings__Lbl_Menu_Resources',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigComboBox({
            key: 'Machine',
            label: 'Settings__Lbl_Menu_Devices',
            valueField: nameOf<IMachine>('Id'),
            textField: nameOf<IMachine>('NameWithSign'),
            options: this.machineStore.Machines$,
            valuePrimitive: true,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'Instrument',
            label: 'Docu_Ini__Tool',
            valueField: nameOf<IInstrument>('Id'),
            textField: nameOf<IInstrument>('Name'),
            options: this.instrumentStore.Instruments$,
            valuePrimitive: true,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'Driver',
            label: 'Docu_Ini__Motorist',
            valueField: nameOf<IDriver>('Id'),
            textField: nameOf<IDriver>('ShortFullName'),
            options: this.driverStore.Drivers$,
            valuePrimitive: true,
            sort: 1
          }),
          new ApDynformsConfigPlaceholder()
        ]
      })
    ];
  }

  private _fieldSets(dataItem: INFertilizationBookingGridData, formChanges$: Observable<any>): ApDynformsConfigFieldset[] {
    const selectedCampaignYear = this.campaignYearStore.getSelectedCampaignYear().Year;
    const campaignYearRange = this.campaignYearService.getCampaignYearRange(selectedCampaignYear);
    return [
      new ApDynformsConfigFieldset({
        key: 'Agronomy',
        legend: 'Global__Agronomy',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigNumerictextbox({
            key: 'Average',
            label: 'Nutrients__Average_Amount_Nutrient_kg_N_per_ha',
            value$: formChanges$.pipe(
              filter(values => values && (values['Applied'] >= 0 || values['Average'] >= 0)),
              map(values => this._isApplicationRateValid(dataItem.ApplicationRate) ? values['Applied'] * dataItem.FertilizerAreaFactor : values['Average'])
            ),
            value: dataItem.Average * dataItem.FertilizerAreaFactor,
            min: 0,
            disabled: true
          }),
          new ApDynformsConfigNumerictextbox({
            key: 'Applied',
            label: this._getGoodsLabel(dataItem.Fertilizer),
            value$: formChanges$.pipe(
              filter(values => values && (values['Average'] >= 0 || values['Applied'] >= 0)),
              map(values => !this._isApplicationRateValid(dataItem.ApplicationRate) ? values['Average'] / dataItem.FertilizerAreaFactor : values['Applied'])
            ),
            min: 0,
            value: dataItem.Applied,
            decimals: 0,
            disabled: !this._isApplicationRateValid(dataItem.ApplicationRate)
          }),
        ]
      }),
      new ApDynformsConfigFieldset({
        key: 'Time',
        legend: 'Docu_Ini__Time',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigDatepicker({
            key: 'FertilizationDate',
            label: 'Nutrients__FertilizationDate',
            value$: this.modalDialogStore.listenChanges().pipe(
              filter(values => values && values['FertilizationDate']),
              map(values => values['FertilizationDate'])
            ),
            value: dataItem.FertilizationDate,
            minDate: campaignYearRange.StartYear,
            maxDate: campaignYearRange.EndYear
          }),
          new ApDynformsConfigTimepicker({
            key: 'Duration',
            label: 'Docu_Ini__Duration',
            format: 'HH:mm',
            value: dataItem.Duration,
            minSteps: 5,
            secSteps: 60
          })
        ]
      }),
      new ApDynformsConfigFieldset({
        key: 'Resources',
        legend: 'Settings__Lbl_Menu_Resources',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigComboBox({
            key: 'Machine',
            label: 'Settings__Lbl_Menu_Devices',
            valueField: nameOf<IMachine>('Id'),
            textField: nameOf<IMachine>('NameWithSign'),
            valuePrimitive: true,
            value: dataItem.Machine?.Id,
            value$: formChanges$.pipe(
              filter(values => !!values['Machine']),
              map(values => values['Machine'])
            ),
            options: this.machineStore.Machines$,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'Instrument',
            label: 'Docu_Ini__Tool',
            valueField: nameOf<IInstrument>('Id'),
            textField: nameOf<IInstrument>('Name'),
            valuePrimitive: true,
            value: dataItem.Instrument?.Id,
            value$: formChanges$.pipe(
              filter(values => !!values['Machine'] || !!values['Instrument']),
              map(values => {
                if (!!values['Instrument']) {
                  return values['Instrument'];
                }
                const formValues = this.modalDialogStore.getFormValues();
                if (!!formValues['Instrument']) {
                  return formValues['Instrument'];
                }
                const machine = this.machineStore.getMachineById(values['Machine']);
                if (!!machine?.DefaultInstrument?.Id) {
                  return machine.DefaultInstrument.Id;
                }
                return undefined;
              })
            ),
            options: this.instrumentStore.Instruments$,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'Driver',
            label: 'Docu_Ini__Motorist',
            valueField: nameOf<IDriver>('Id'),
            textField: nameOf<IDriver>('ShortFullName'),
            valuePrimitive: true,
            value: dataItem.Driver?.Id,
            value$: formChanges$.pipe(
              filter(values => !!values['Machine'] || !!values['Driver']),
              map(values => {
                if (values['Driver']) {
                  return values['Driver'];
                }
                const formValues = this.modalDialogStore.getFormValues();
                if (formValues['Driver']) {
                  return formValues['Driver'];
                }
                const machine = this.machineStore.getMachineById(values['Machine']);
                if (!!machine?.DefaultDriver?.Id) {
                  return machine.DefaultDriver.Id;
                }
                return null;
              })
            ),
            options: this.driverStore.Drivers$,
            sort: 1
          }),
          new ApDynformsConfigPlaceholder()
        ]
      }),
    ];
  }

  private _isApplicationRateValid(applicationRate: number | null): boolean {
    return applicationRate && applicationRate > 0;
  }

  private _getGridStatus(status: TaskManagementStatus): { Class: string, Desc: string } {
    switch (status) {
      case TaskManagementStatus.Green:
        return {Class: 'ap-status-green', Desc: ''};
      case TaskManagementStatus.Yellow:
        return {Class: 'ap-status-yellow', Desc: ''};
      case TaskManagementStatus.Red:
        return {Class: 'ap-status-red', Desc: ''};
    }
  }

  private _getGoodsLabel(fertilizer: CombinedFertilizer): string {
    switch (fertilizer?.Unit?.Description) {
      case 'm³':
        return 'Global__GoodsSpread_m3';
      case 'l':
        return 'Global__GoodsSpread_l';
      case 't':
        return 'Global__GoodsSpread_t';
      default:
        return 'Global__GoodsSpread_kg';
    }
  }
}
